<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-3" *ngIf="service.editable" (click)="submit()">Zapisz</button>
	<button class="btn btn-primary me-3" *ngIf="pageFunction === 'edit' && !service.editable" (click)="editUnlock()">
		Edycja
	</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<mat-tab-group class="container mt-3" dynamicHeight animationDuration="0ms">
	<mat-tab label="Dane  obowiązkowe">
		<ng-template matTabContent>
			<app-service-basic [editable]="service.editable"></app-service-basic>
		</ng-template>
	</mat-tab>
	<mat-tab label="Dane dodatkowe">
		<app-service-additional></app-service-additional>
	</mat-tab>
	<mat-tab label="Multimedia">
		<app-service-multimedia></app-service-multimedia>
	</mat-tab>
</mat-tab-group>
